<template>
    <v-app style="height:100%">
    <app-bar class="mr-4 mr-md-10"/>
    <v-main>
        <v-container fluid id="MyContainerTopFull" class="px-md-10 pt-5">
          <slot></slot>
        </v-container>
    </v-main>
  </v-app>
</template>

<script>
  import AppBar from './AppBar';
  export default {
    name: 'TopView',
    components: {
      AppBar,
    },
  }
</script>

<style lang="scss" scoped>
   #MyContainerTopFull{
      width: 100%;
      height: 100%;
      background-color: #ECEEF2;
      background-image: url('../../../assets/main_background.png');
      -webkit-background-size: cover;
      -moz-background-size: cover;
      -o-background-size: cover;
      background-size: cover;

  }
   @media screen and (max-width: 960) {
    #MyContainerTopFull{
     padding: 0px;
    //  margin: 0px
    }
  }
</style>